import { useState } from 'react'

import { Button } from '@/components/ui/Button'
import { toApiError } from '@/lib/api/errors'

/**
 * 두 CSV EP(정산 회차·환불 결과) 공용 다운로드 버튼(설계 §2).
 *
 * 🚨 파일 저장 자체는 `onDownload`(각 api 함수, `downloadBlob` 호출)가 끝낸다 — 이 컴포넌트는
 * 로딩·에러 상태만 관리한다(브라우저 다운로드 트리거는 side effect라 이 화면이 알 필요 없다).
 */
export function CsvDownloadButton({
  label = 'CSV 다운로드',
  onDownload,
}: {
  label?: string
  onDownload: () => Promise<void>
}) {
  const [isDownloading, setIsDownloading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  async function handleClick() {
    setIsDownloading(true)
    setErrorMessage(null)
    try {
      await onDownload()
    } catch (error) {
      setErrorMessage(toApiError(error).message)
    } finally {
      setIsDownloading(false)
    }
  }

  return (
    <div className="flex flex-col items-end gap-1">
      <Button
        variant="secondary"
        size="sm"
        disabled={isDownloading}
        onClick={() => {
          void handleClick()
        }}
      >
        {isDownloading ? '다운로드 중…' : label}
      </Button>
      {errorMessage ? (
        <p role="alert" className="text-xs text-danger-500">
          {errorMessage}
        </p>
      ) : null}
    </div>
  )
}
